<template lang="pug">
el-dialog(
  :title="!ruleForm.id ? '新建比赛' : '修改比赛信息'",
  class="el-dialog-custom",
  top="3vh",
  width="95%",
  :visible.sync="visible",
  @open="openForm()",
  :append-to-body="true",
  :modal-append-to-body="false",
  @close="closeForm()"
)
  el-form(
    :model="ruleForm",
    :inline="false",
    :rules="rules",
    ref="ruleForm",
    label-width="140px",
    @submit.native.prevent
  )
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 比赛设置
      div
      el-form-item(label="比赛ID:", prop="matchId", v-show="false")
        el-input.width_ct(v-model="ruleForm.matchId", disabled)
        font.font_later(v-if="!ruleForm.matchId") 新建后自动生成!
      el-form-item(label="比赛名称:", prop="matchName")
        el-input.width_ct(
          v-model="ruleForm.matchName",
          @input="descInput",
          placeholder="请填写比赛名称",
          type="text",
          maxlength="40",
          show-word-limit
        )
        font.font_later 您还可以输入
        font.font_style {{ nameFont }}
        font.font_color 个字!
      el-form-item(label="主办方:", prop="userGroupId")
        el-select.sel_width_ct(
          v-model="ruleForm.userGroupId",
          placeholder="请选择主办方",
          filterable,
          clearable,
          @change="changeCity"
        )
          el-option(
            v-for="(item, index) in sysOrgList",
            :key="index",
            :label="item.name",
            :value="item.orgId"
          )
      el-form-item(label="主办城市:", prop="city")
        el-col(style="width: 20%")
          el-select(
            v-model="ruleForm.provinceCode",
            placeholder="请选择省",
            style="width: 100%",
            :disabled="cityDisbaled",
            @change="changeProvice"
          )
            el-option(
              v-for="(item, index) in provinceList",
              :key="index",
              :label="item.name",
              :value="item.code"
            )
        el-col.line(style="width: 2%") &nbsp;&nbsp;省&nbsp;&nbsp;
        el-col(style="width: 20%")
          el-select(
            v-model="ruleForm.cityCode",
            placeholder="请选择市",
            style="width: 100%",
            :disabled="provinceDisabled",
            @change="selectCity"
          )
            el-option(
              v-for="(item, index) in cityList",
              :key="index",
              :label="item.cityname",
              :value="item.citycode"
            )
        el-col(style="width: 20%") &nbsp;&nbsp;市&nbsp;
      el-form-item(label="比赛场地:", prop="venueId")
        el-select.sel_width_ct(
          v-model="ruleForm.venueId",
          placeholder="请选择比赛场地",
          clearable,
          :disabled="venueIdDisabled",
          @change="venueIdChange"
        )
          el-option(
            v-for="(item, index) in venueList",
            :key="index",
            :label="item.name",
            :value="item.id"
          )
        font.font_later(v-if="ruleForm.venueAddress") 地址: {{ ruleForm.venueAddress }}
      el-form-item(label="比赛类型:", prop="ctType")
        el-select.sel_width_ct(
          v-model="ruleForm.ctType",
          placeholder="请选择比赛类型",
          clearable
        )
          el-option(
            v-for="(item, index) in ctTypeList",
            :label="item.label",
            :value="item.key"
          )
      el-form-item(label="签位:", prop="applySize")
        el-input.sel_width_ct(
          v-model="ruleForm.applySize",
          @change="changeappsize",
          :min="1",
          clearable,
          :disabled="isReviewedEdit && ruleForm.inGameManagementMode != 0",
          placeholder="请填写签位数"
        )
          template(slot="suffix") 签位
      el-form-item(label="报名时间:", prop="applyDate")
        el-date-picker(
          v-model="ruleForm.applyDate",
          @blur="applyDateChange",
          range-separator="至",
          type="datetimerange",
          start-placeholder="开始时间",
          end-placeholder="截止时间",
          :picker-options="pickerOptions",
          format="yyyy-MM-dd HH:mm",
          value-format="yyyy-MM-dd HH:mm",
          clearable
        )
      el-form-item(label="比赛时间:", prop="matchStartTime")
        el-date-picker.sel_width_ct(
          v-model="ruleForm.matchStartTime",
          type="datetime",
          :disabled="ctDisabled",
          :placeholder="matchStartTimePlaceholder",
          format="yyyy-MM-dd HH:mm",
          @change="changeMatchStartTime",
          :picker-options="pickerOptionsCt",
          value-format="yyyy-MM-dd HH:mm",
          :clearable="false"
        )
      el-form-item(label="比赛项目:", prop="projectType")
        el-select.sel_width_ct(
          v-model="ruleForm.projectType",
          placeholder="请选择比赛项目",
          @change="changeProjectType",
          :disabled="ruleForm.id && ruleForm.matchStatus !== 1 && ruleForm.matchStatus !== 5",
          clearable
        )
          el-option(label="单打", :value="1")
          el-option(label="双打", :value="2")
          el-option(label="双打配对赛", :value="3")
      el-form-item(
        label="双打级别差:",
        prop="doubleLevelGap",
        v-if="ruleForm.projectType == 2"
      )
        el-select.sel_width_ct(
          v-model="ruleForm.doubleLevelGap",
          placeholder="请选择双打级别差",
          clearable
        )
          el-option(
            v-for="item in levelOptionsThree",
            :label="item.label",
            :value="item.value"
          )
      el-row(style="width: 100%")
        el-col(style="width: 26.5%")
          el-form-item(label="级别", prop="smallLevel")
            el-select(
              style="width:100%"
              v-model="ruleForm.smallLevel",
              :disabled="levelDisabled",
              clearable,
              @change="changeSmallLevel",
              :placeholder="placeholderLevel"
            )
                el-option(
                  v-for="item in levelOptions",
                  :label="item.label",
                  :value="item.value"
                )
        el-col(style="width: 2%;display:flex;align-items:center;line-height: 40px;margin-left:25px") 至
        el-col(style="width: 18%")
          el-form-item(label="",label-width="0", prop="bigLevel")
            el-select(
            style="width:100%;"
            v-model="ruleForm.bigLevel",
            :disabled="levelDisabled",
            clearable,
            @change="changeBigLevel",
            :placeholder="placeholderLevel"
          )
              el-option(
                v-for="item in levelOptions",
                :label="item.label",
                :value="item.value"
              )
      //- 迭代三
      //- el-form-item(label="胜负判定方:", prop="outcomeType")
      //-   el-radio(v-model="ruleForm.outcomeType", :label="0") 胜场制
      //-   el-radio(v-model="ruleForm.outcomeType", :label="1") 积分制
      //- 添加无赛中模式
      el-form-item(label="赛中管理模式:", prop="inGameManagementMode")
        el-radio(v-model="ruleForm.inGameManagementMode", :label="1", :disabled="isInGameManagementMode") 赛中管理
        el-radio(v-model="ruleForm.inGameManagementMode", :label="0") 无赛中管理
      div(style="margin-bottom: 22px; height: 40px; display: flex; align-items: center; color: #606266;")
        div(style="padding-right: 12px; width: 128px; text-align: right;") 场地数量:
        div(style="color: #303133;") {{ ruleForm.__placeInfoTemp__.length }}
      el-form-item(
        v-if="ruleForm.inGameManagementMode == 1"
        label="场地信息:"
        style="margin-bottom: 0;"
        required
      )
        el-form-item(
          v-for="(item, index) in ruleForm.__placeInfoTemp__",
          :prop="`__placeInfoTemp__[${index}].name`"
          :rules="[{ required: true, message: '请填写场地信息!', trigger: 'blur' }]"
          style="display: inline-block; margin-right: 10px; margin-bottom: 22px; width: 238px;"
        )
          el-input(
            v-model="item.name",
            clearable,
            placeholder="请填写场地信息"
          )
        i(
          class="el-icon-circle-plus-outline"
          style="margin-right: 5px; font-size: 28px; cursor: pointer; transform: translateY(6px);"
          @click="addPlaceInfoTemp"
        )
        i(
          v-if="ruleForm.__placeInfoTemp__.length > 1"
          class="el-icon-remove-outline"
          style="font-size: 28px; cursor: pointer; transform: translateY(6px);"
          @click="deletePlaceInfoTemp"
        )
      el-form-item(
        label="第一阶段赛制:",
        prop="FirstCompetition",
        v-if="ruleForm.inGameManagementMode == 1"
      )
        el-col(style="width: 15%")
          el-select(
            v-model="ruleForm.FirstCompetition",
            style="width: 100%",
            placeholder="请选择赛制",
            @change="changeFirstCompetition",
            :disabled="isReviewedEdit",
            clearable
          )
            el-option(
              v-for="(item, index) in FirstCompetition",
              :label="item.label",
              :value="item.value",
              :disabled="item.disabled"
            )
        el-col.line(style="width: 8%; text-align: right") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*组数&nbsp;&nbsp;
        el-col(style="width: 15%")
          el-input(
            v-model="ruleForm.groupNum",
            :disabled="[0, 5, 6, 7].includes(ruleForm.FirstCompetition) || isReviewedEdit",
            @input="changeGroupNum",
            @change="changeGpnumber",
            style="width: 100%",
            clearable,
            placeholder="请填写组数"
          )
        el-col.line(style="width: 8%; text-align: right") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*设置附加规则&nbsp;&nbsp;
        el-col(style="width: 15%")
          el-select(
            v-model="ruleForm.allowPlayOff",
            style="width: 100%",
            placeholder="请选择附加规则",
            @change="changeAllowPlayOff",
            :disabled="(ruleForm.FirstCompetition !== 5) || isReviewedEdit"
          )
            el-option(
              v-for="(item, index) in allowPlayOffData",
              :label="item.label",
              :value="item.value"
            )

        el-col.line(style="width: 8%; text-align: right") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*小组晋级人数&nbsp;&nbsp;
        el-col(style="width: 15%")
          el-input(
            v-model="ruleForm.groupRiseNum",
             @input="changeGroupNum",
            :disabled="(ruleForm.FirstCompetition === 1 ? false : true) || isReviewedEdit",
            @blur="promotedNumber",
            style="width: 100%",
            clearable,
            placeholder="请填写晋级人数"
          )
      el-form-item(label="第二阶段赛制:", v-if="ruleForm.inGameManagementMode == 1")
        el-col(style="width: 15%")
          el-select(
            v-model="ruleForm.SecondCompetition",
            style="width: 100%",
            placeholder="请选择赛制",
            @change="changeSecondCompeti",
            clearable,
            :disabled="(ruleForm.FirstCompetition === 1 && ruleForm.groupNum != 1 && ruleForm.groupNum != '' ? false : true) || isReviewedEdit"
          )
            el-option(
              v-for="(item, index) in SecondCompetition",
              :label="item.label",
              :value="item.value"
            )
        el-col.line(style="width: 8%; text-align: right") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*交叉数&nbsp;&nbsp;
        el-col(style="width: 15%")
          el-select(
            v-model="ruleForm.crossNum",
            style="width: 100%",
            placeholder="请选择交叉数",
            @change="changecrossNum",
            clearable,
            :disabled="(ruleForm.SecondCompetition == 4 ? false : true) || isReviewedEdit"
          )
            el-option(
              v-for="(item, index) in CrossingNum",
              :label="item.label",
              :value="item.value"
            )
        el-col.line(style="width: 8%; text-align: right") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*设置附加规则&nbsp;&nbsp;
        el-col(style="width: 15%")
          el-form-item(label="", prop="allowPlayOff1")
            el-select(
              v-model="ruleForm.allowPlayOff1",
              style="width: 100%",
              placeholder="请选择附加规则",
              @change="changeAllowPlayOff1",
              :disabled="(ruleForm.SecondCompetition !== 5) || isReviewedEdit"
            )
              el-option(
                v-for="(item, index) in allowPlayOffData",
                :label="item.label",
                :value="item.value",
                :disabled="item.value === 1 && (ruleForm.groupNum * ruleForm.groupRiseNum) === 2"
              )

      el-form-item(label="是否替补:", prop="bench")
        el-radio(v-model="ruleForm.bench", :label="1") 是
        el-radio(v-model="ruleForm.bench", :label="0") 否

      el-form-item(label="联系电话:", prop="contactMobile")
        el-input.sel_width_ct(
          v-model="ruleForm.contactMobile",
          placeholder="请填写联系电话",
          type="text",
          maxlength="11"
          clearable
        )
      el-form-item(label="列表页图:", prop="imgList")
        el-input(v-model="ruleForm.imgList", v-show="false")
          //- el-upload(:http-request="uploadFileList",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
        img.avatar(
          v-if="listImageUrl",
          :src="listImageUrl",
          style="width: 256px; height: 190px",
          @click="openImgdailog(1)"
        )
        i.el-icon-plus.avatar-uploader-icon(
          v-else,
          style="width: 240px; height: 174px",
          @click="openImgdailog(1)"
        )
        imgupload(
          v-if="openImg",
          ref="upimg",
          :width="256",
          :height="190",
          @uploadSuccess="doneup_lb"
        )
        el-alert(
          title="建议最小分辨率256×190,上传图片格式仅支持jpg,jpeg,png,大小不超过10M",
          effect="light",
          :closable="false",
          style="margin-top: 10px"
        )
      el-form-item(label="详情页图:", prop="imgDetailList")
        el-input(v-model="ruleForm.imgDetailList", v-show="false")
          //- el-upload(:http-request="uploadFileDetail",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
        img.avatar(
          v-if="detailImageUrl",
          :src="detailImageUrl",
          style="width: 750px; height: 310px",
          @click="openImgdailog(2)"
        )
        i.el-icon-plus.avatar-uploader-icon(
          v-else,
          style="width: 317px; height: 178px",
          @click="openImgdailog(2)"
        )
        imgupload(
          v-if="openImg",
          ref="upimg2",
          :width="750",
          :height="310",
          @uploadSuccess="doneup_xq"
        )
        el-alert(
          title="建议最小分辨率750×310,上传图片格式仅支持jpg,jpeg,png,大小不超过10M",
          effect="light",
          :closable="false",
          style="margin-top: 10px"
        )
      el-form-item(label="比赛简介:", prop="matchDescription")
        el-input(
          v-model="ruleForm.matchDescription",
          type="textarea",
          style="display: none"
        )
        d2-quill(
          v-show="showQuill"
          ref="d2-quill",
          v-model="ruleForm.matchDescription",
          style="min-height: 200px"
        )
      el-form-item(label="报名须知:", prop="gameDescription")
        d2-quill(
          v-show="showQuill"
          ref="gameDescription",
          v-model="ruleForm.gameDescription",
          style="min-height: 200px"
        )
      el-form-item(label="比赛规程:", prop="imgDetailList")
        <div v-for="(item,index) in pdfs" style="display:flex">
          <div style="width:600px"> {{ item.fileName }}</div>
          <div v-if="item.loading"> ({{ item.loading }}%)</div>
          <a v-if="item.loading == 100" :href="item.url" target="_blank" style="text-decoration: none;margin-left:50px"> 下载</a>
          <div v-if="item.loading == 100" @click="deletePdf(index)" style="margin-left:50px"> 删除</div>
        </div>
        el-upload.upload-demo(
          drag,
          action=process.env.VUE_APP_API + "/admin/upload/uploadFile",
          :on-error="loadingFail",
          :before-upload="handleLoading",
          :on-success="savePdfUrl",
          :show-file-list="false",
          :data="uploadData",
          :headers="uploadHeader",
          style="max-width: 500px"
        )
          i.el-icon-upload
          .el-upload__text 将文件拖到此处，或
            em 点击上传
        el-alert(
          title="上传格式仅支持是.pdf，.doc或.docx,大小不超过10M",
          effect="light",
          :closable="false",
          style="margin-top: 10px"
        )
    br
    el-card(shadow="never")
      div(slot="header")
      font(style="font-weight: bold; font-size: 18px") 报名限定
      div
      el-form-item(label="重复报名:", prop="repeatSign")
        el-radio(:label=0, v-model="ruleForm.repeatSign") 不允许
        el-radio(:label=1, v-model="ruleForm.repeatSign") 允许
      el-form-item(label="性别限定:", prop="genderLimit")
        el-radio-group(
          v-model="ruleForm.genderLimit",
          @change="genderLimitChange"
        )
          el-radio(:label="2") 全部
          el-radio(:label="0", style="margin-left: 14px") 男
          el-radio(:label="1") 女
      el-form-item(label="年龄限定:")
        font &nbsp;男选手&nbsp;
        el-input-number(
          v-model="ruleForm.ageMinMen",
          :disabled="menDisabled",
          :min=0,
          :max="ageMaxMenMax",
          @change="startAgeMenChange"
        )
        font &nbsp;至&nbsp;
        el-input-number(
          v-model="ruleForm.ageMaxMen",
          :disabled="menDisabled",
          :min="ageMaxMenMin",
          :max=100,
          @change="endAgeMenChange"
        )
        font &nbsp;岁&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;女选手&nbsp;
        el-input-number(
          v-model="ruleForm.ageMinWomen",
          :disabled="womenDisabled",
          :min=0,
          :max="ageMaxWomenMax",
          @change="startAgeWomenChange"
        )
        font &nbsp;至&nbsp;
        el-input-number(
          v-model="ruleForm.ageMaxWomen",
          :disabled="womenDisabled",
          :min="ageMaxWomenMin",
          :max=100,
          @change="endAgeWomenChange"
        )
        font &nbsp;岁
      .rankLimit
        el-form-item(label="级别限定:", prop="minLevel")
          el-select.select_width(
            v-model="ruleForm.minLevel",
            clearable,
            :disabled="levelDisabled",
            :placeholder="placeholderLevel"
          )
            el-option(
              v-for="(e, i) in pxLevel1",
              :label="e.label",
              :value="e.value",
              :disabled="e.disabled",
              :key="i"
            )
        .empty 至
        el-form-item.ageStyle(label="", prop="maxLevel")
          el-select.select_width(
            v-model="ruleForm.maxLevel",
            clearable,
            :disabled="levelDisabled",
            :placeholder="placeholderLevel"
          )
            el-option(
              v-for="(e, i) in pxLevel2",
              :label="e.label",
              :value="e.value",
              :disabled="e.disabled",
              :key="i"
            )
        //- el-button.btn(@click="levelAll", plain, :disabled="levelDisabled") 不限级别
      el-form-item(label="年度积分≥", prop="scoreMin")
        el-input-number(
          v-model="ruleForm.scoreMin",
          :min="0",
          :max="100000000",
          style="margin-left: 50px"
        )
        font.font_later 请限定选手年度积分！
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 报名费用
      div
        el-row(style="padding-bottom: 15px", :span="24")
          el-col(:md="23", :sm="5")
            el-button(@click="addFeeTemplate(1)", type="primary") 选择模板
        el-table(:data="ruleForm.ctEnrollPriceList", border)
          el-table-column(prop="name", label="角色", align="center")
          el-table-column(prop="type", label="报名费用", align="center")
            template(slot-scope="scope")
              font ￥&nbsp;&nbsp;
              el-input-number(
                v-model="scope.row.price",
                :precision="2",
                :min="0",
                :max="1000000"
              )
              font &nbsp;&nbsp;&nbsp;&nbsp;元

    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 退款设置
      div
        el-row(style="padding-bottom: 15px", :span="24")
          el-col(:md="23", :sm="5")
            el-button(@click="addFeeTemplate(2)", type="primary") 选择模板
        el-row
          el-col(:span="8")
            el-form-item(label="距比赛开始≤", label-width="auto")
              el-input-number(
                v-model="ctRefund.minDuration",
                :min="0",
                :max="100000000",
                :step="1"
              )
              font &nbsp;&nbsp;&nbsp;小时
          el-col(:span="8")
            el-form-item(label="退款比例:")
              el-input-number(
                v-model="ctRefund.refundScale",
                :min="0",
                :max="100"
              )
              font &nbsp;&nbsp;&nbsp;%
          el-col(:span="8")
            div(style="float: right")
              el-button(@click="addCtRefund", type="primary") 添 加
              el-button(
                @click="delCtRefund",
                type="danger",
                :disabled="delCtRefundDisabled"
              ) 删 除
        el-table(
          :data="ruleForm.ctRefundList",
          border,
          @selection-change="selectionChangeHandle"
        )
          el-table-column(type="selection", align="center", width="50")
          el-table-column(
            prop="index",
            label="序号",
            align="center",
            width="100"
          )
          el-table-column(
            prop="minDuration",
            label="距比赛开始时间/小时（含）",
            align="center"
          )
          el-table-column(prop="refundScale", label="退款比例/%", align="center")
    br
    el-card(shadow="never")
      div(slot="header")
        font(style="font-weight: bold; font-size: 18px") 电子证书设置
      el-select.sel_width_ct(
        v-model="ruleForm.prizeList",
        clearable,
        placeholder="请选择奖项等级",
        style="margin-bottom: 10px"
      )
        el-option(
          v-for="item in prizeList",
          :label="item.label",
          :value="item.key"
        )
      el-form-item(label="电子证书图:", prop="CertimgList")
        i.el-icon-plus.avatar-uploader-icon(
          style="width: 240px; height: 174px",
          @click="openImgdailog(3)"
        )
        .imagemore
          .imagelist
            .infocont(
              v-for="(item, index) in listImageUrlCert",
              @mouseenter="hoverover(item)",
              @mouseleave="hoverout(item)"
            )
              .deletes(v-if="deletesId === item.imgUrl")
                .Mask
                div
                i(:class="activecolor===item.imgUrl?'el-icon-delete chosecolor':'el-icon-delete'" @mouseenter="hoverover1(item)" @mouseleave="hoverout2(item)" @click="deletecertImg(item,index)")
              div
              img.avatar(
                v-if="listImageUrlCert",
                :src="item.imgUrl",
                style="width: 240px; height: 174px",
                @click="openImgdailog(3)"
              )
              span {{ item.rewardLevel == 1 ? "一等奖" : item.rewardLevel == 2 ? "二等奖" : item.rewardLevel == 3 ? "三等奖" : item.rewardLevel == 4 ? "四等奖" : "" }}
            div
          div
        div
        imguploadMD(
          v-if="openImg",
          ref="upimg3",
          :width="240",
          :height="174",
          @uploadSuccess="doneup_Cert"
        )
      el-alert(
        title="建议最小分辨率240×175,上传图片格式仅支持jpg,jpeg,png,大小不超过10M",
        effect="light",
        :closable="false",
        style="margin-top: 10px"
      )
  span.dialog-footer(slot="footer")
    el-button(type="primary", @click="ruleFormSubmit()", :disabled="clickFlag") 确 定
    el-button(@click="closeForm()") 取 消

  //- 选择模板
  addFeeTemplate(
    v-if="addFeeTemplateVisible",
    ref="addFeeTemplate",
    @chooseTemplate="chooseTemplate"
  )
</template>

<script>
import util from '@/libs/util.js';
import { commomDictData } from '@/util/dictionary'; // 字典项
import addFeeTemplate from '../../../operation/fee/add-fee-template.vue';
export default {
  components: {
    addFeeTemplate,
  },
  data () {
    var matchDscRule = (rule, value, callback) => {
      if (!value || value === '<p><br></p>') {
        callback(new Error('比赛简介不能为空!'));
      } else {
        callback();
      }
    };
    var leaveLimitStr = (rule, value, callback) => {
      if (value !== 0 && !value) {
        return callback(new Error('必须限制会员级别！'));
      } else if (this.ruleForm.maxLevel) {
        setTimeout(() => {
          if (this.ruleForm.minLevel * 1 > this.ruleForm.maxLevel * 1) {
            callback(new Error('级别范围错误！'));
          } else {
            callback();
          }
        }, 100);
      }
    };
    var leaveLimitEnd = (rule, value, callback) => {
      if (value !== 0 && !value) {
        return callback(new Error('必须限制会员级别！'));
      } else {
        setTimeout(() => {
          if (this.ruleForm.minLevel * 1 > this.ruleForm.maxLevel * 1) {
            callback(new Error('最小级别应小于或等于最大级别，请重新选择！'));
          } else {
            callback();
          }
        }, 100);
      }
    };
    var smallLevelRule = (rule, value, callback) => {
      // debugger
      if (value !== 0 && !value) {
        return callback(new Error('必须选择级别！'));
      } else if (this.ruleForm.bigLevel) {
        setTimeout(() => {
          if (this.ruleForm.smallLevel * 1 > this.ruleForm.bigLevel * 1) {
            callback(new Error('级别范围错误！'));
          } else {
            callback();
          }
        }, 100);
      }
    };
    var bigLevelRule = (rule, value, callback) => {
      // debugger
      if (value !== 0 && !value) {
        return callback(new Error('必须选择级别！'));
      } else {
        setTimeout(() => {
          if (this.ruleForm.smallLevel * 1 > this.ruleForm.bigLevel * 1) {
            callback(new Error('最小级别应小于或等于最大级别，请重新选择！'));
          } else {
            callback();
          }
        }, 100);
      }
    };
    return {
      pdfs: [],
      // 审核状态编辑？
      isReviewedEdit: false,
      // 比赛赛制 为0时不可编辑
      isInGameManagementMode: false,
      uploadHeader: {
        token: util.cookies.get('token'),
        authorization: 'Bearer ' + util.cookies.get('authorization'),
        // 'Content-Type': 'application/json; charset=utf-8'
      },
      pdfUrl: '',
      uploadData: {
        type: 'ctLevel',
      },
      FirstShow: false,
      SecondShow: false,
      activecolor: -1,
      deletesId: -1,
      ctRefund: {
        index: 0,
        minDuration: 0,
        refundScale: 0,
      },
      addFeeTemplateVisible: false,
      clickFlag: false,
      delTableList: [],
      sysOrgList: [],
      cityList: [],
      provinceList: [],
      delCtRefundDisabled: true,
      cityDisbaled: true,
      provinceDisabled: true,
      nameFont: 40,
      venueIdDisabled: true,
      venueList: [],
      placesInfoList: [],
      ageMaxMenMin: 0,
      ageMaxWomenMin: 0,
      ageMaxMenMax: 100,
      ageMaxWomenMax: 100,
      menDisabled: false,
      womenDisabled: false,
      ruleForm: {
        smallLevel: '',
        bigLevel: '',
        groupRiseNum: '',
        id: null,
        matchType: '1',
        matchId: '',
        matchName: '',
        userGroupId: '',
        cityCode: '',
        cityName: '',
        provinceCode: '',
        provinceName: '',
        venueId: '',
        ctType: '',
        applySize: '',
        projectType: null,
        doubleLevelGap: '', //双打级别差
        level: '',
        bench: 1,
        contactMobile: '',
        applyDate: [],
        matchSignStartTime: null,
        matchSignEndTime: null,
        matchStartTime: null,
        imgList: '',
        gameDescription: '',
        matchDescription: '',
        imgDetailList: '',
        CertimgList: '',
        repeatSign: 1,
        genderLimit: 2,
        ageLimit: '',
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: 0,
        venueAddress: '',
        ctRefundList: [],
        inGameManagementMode: 1,
        placeInfo: '',
        __placeInfoTemp__: [],
        // outcomeType: 0,

        competitionMatchFormatList: [
          {
            matchFormat: '',
            stage: 1,
            groupNum: '',
          },
          {
            matchFormat: '',
            stage: 2,
            crossNum: '',
          },
        ],
        ctEnrollPriceList: [
          {
            id: null,
            name: '注册会员',
            type: 1,
            price: 0.0,
          },
          {
            id: null,
            name: '初始会员',
            type: 2,
            price: 0.0,
          },
          {
            id: null,
            name: '荣誉会员',
            type: 3,
            price: 0.0,
          },
        ],
        matchFormat: '', // 赛制
        recommend: 0, // 是否首页推荐
        FirstCompetition: '',
        SecondCompetition: '',
        crossNum: '',
        groupNum: '',
        ecertList: [], //电子证书设置
        minLevel: null, //级别限定
        maxLevel: null,
        allowPlayOff: null, //设置附加规则 第一阶段
        allowPlayOff1: null, //设置附加规则 第二阶段
      },
      SecondCompetition: [
        { value: 2, label: '同名次小组循环赛' },
        { value: 3, label: '同名次淘汰附加赛' },
        { value: 4, label: '交叉淘汰附加赛' },
        { value: 5, label: '淘汰赛' },
      ],
      FirstCompetition: [
        { value: 0, label: '淘汰附加赛' },
        { value: 1, label: '小组循环赛' },
        { value: 5, label: '淘汰赛' },
				{ value: 6, label: '6签位循环赛', disabled: true },
				{ value: 7, label: '3局2胜赛', disabled: true }
      ],
      CrossingNum: [
        { value: '2', label: '2' },
        // { value: '4', label: '4' },
        // { value: '8', label: '8' }
      ],
      flagType: '',
      loading: null,
      ctDisabled: true,
      matchStartTimePlaceholder: '必须先选择报名时间',
      // pickerOptions: null,
      pickerOptions: {
        // disabledDate: time => {
        //     return (
        //         time <= new Date()
        //     )
        // }
      },
      pickerOptionsCt: null,
      // restaurants:[],
      levelDisabled: true,
      levelOptions: [],
      levelOptionsOne: [
        { value: '2.0', label: '2.0' },
        { value: '2.5', label: '2.5' },
        { value: '3.0', label: '3.0' },
        { value: '3.5', label: '3.5' },
        { value: '4.0', label: '4.0' },
        { value: '4.5', label: '4.5' },
        { value: '5.0', label: '5.0' },
      ],
      levelOptionsTwo: [
        { value: '5.0', label: '5.0' },
        { value: '5.5', label: '5.5' },
        { value: '6.0', label: '6.0' },
        { value: '6.5', label: '6.5' },
        { value: '7.0', label: '7.0' },
        { value: '7.5', label: '7.5' },
        { value: '8.0', label: '8.0' },
        { value: '8.5', label: '8.5' },
        { value: '9.0', label: '9.0' },
        { value: '9.5', label: '9.5' },
        { value: '10.0', label: '10.0' },
      ],
      pxLevel_double: [
        { value: '5.0', label: '5.0' },
        { value: '5.5', label: '5.5' },
        { value: '6.0', label: '6.0' },
        { value: '6.5', label: '6.5' },
        { value: '7.0', label: '7.0' },
        { value: '7.5', label: '7.5' },
        { value: '8.0', label: '8.0' },
        { value: '8.5', label: '8.5' },
        { value: '9.0', label: '9.0' },
        { value: '9.5', label: '9.5' },
        { value: '10.0', label: '10.0' },
      ],

      levelOptionsThree: [
        { value: '0', label: '0' },
        { value: '0.5', label: '0.5' },
        { value: '1.0', label: '1.0' },
        { value: '1.5', label: '1.5' },
        { value: '2.0', label: '2.0' },
        { value: '2.5', label: '2.5' },
        { value: '3.0', label: '3.0' },
      ],
      prizeList: [
        { key: 1, label: '一等奖' },
        { key: 2, label: '二等奖' },
        { key: 3, label: '三等奖' },
        { key: 4, label: '四等奖' },
      ],
      ctTypeList: [
        { key: 1, label: '常规赛' },
        { key: 2, label: '月度赛' },
        { key: 3, label: '季度赛' },
        { key: 4, label: '年度总决赛' },
      ],
      placeholderLevel: '必须先选择比赛项目',
      rules: {
        matchName: [
          {
            required: true,
            message: '比赛名称不能为空!',
            trigger: 'blur',
          },
          { max: 40, message: '长度不能超过40个字符!' },
        ],
        userGroupId: [
          {
            required: true,
            message: '主办方不能为空!',
            trigger: 'change',
          },
        ],
        venueId: [
          {
            required: true,
            message: '主办场地不能为空!',
            trigger: 'change',
          },
        ],
        ctType: [
          {
            required: true,
            message: '比赛类型不能为空!',
            trigger: 'change',
          },
        ],
        applySize: [
          {
            required: true,
            message: '签位不能为空!',
            trigger: 'blur',
          },
          {
            max: 10,
            message: '签位不能超过10个字符!',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: '请输入正整数',
            trigger: 'blur',
          },
        ],
        applyDate: [
          {
            required: true,
            message: '报名时间不能为空!',
            trigger: 'change',
          },
        ],
        matchStartTime: [
          {
            required: true,
            message: '比赛时间不能为空!',
            trigger: 'change',
          },
        ],
        projectType: [
          {
            required: true,
            message: '比赛项目不能为空!',
            trigger: 'change',
          },
        ],
        // 双打级别差
        doubleLevelGap: [
          {
            required: true,
            message: '双打级别差不能为空!',
            trigger: 'change',
          },
        ],
        // level: [
        //   {
        //     required: true,
        //     message: '比赛级别不能为空!',
        //     trigger: 'change',
        //   },
        // ],
        inGameManagementMode: [
          {
            required: true,
            message: '赛中管理模式不能为空!',
            trigger: 'change',
          },
        ],
        // outcomeType: [
        //   {
        //     required: true,
        //     message: '胜负方判定不能为空!',
        //     trigger: 'change',
        //   },
        // ],
        matchDescription: [
          {
            required: true,
            validator: matchDscRule,
            trigger: 'change',
          },
          // { max: 1000, message: '长度不能超过1000个字符!' },
        ],
        FirstCompetition: [
          {
            required: true,
            message: '赛制不能为空!',
            trigger: 'change',
          },
        ],
        allowPlayOff1: [
          {
            validator: (rule, value, callback) => {
              if (this.ruleForm.allowPlayOff1 === 1 && (Number(this.ruleForm.groupNum) * Number(this.ruleForm.groupRiseNum) === 2) && this.ruleForm.SecondCompetition === 5) {
                callback(new Error('第一阶段小组晋级人数导致第二阶段参赛队伍为2支，请选择"无附加赛"！'))
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        minLevel: [
          {
            required: true,
            validator: leaveLimitStr,
            trigger: 'change',
          },
        ],
        maxLevel: [
          {
            required: true,
            validator: leaveLimitEnd,
            trigger: 'change',
          },
        ],
        smallLevel: [
          {
            required: true,
            validator: smallLevelRule,
            trigger: 'change',
          },
        ],
        bigLevel: [
          {
            required: true,
            validator: bigLevelRule,
            trigger: 'change',
          },
        ],
        contactMobile: [{
          required: false,
          validator: (rule, value, callback) => {
            if (value && !/^\d{11}$/.test(value)) {
              callback(new Error('请输入正确的联系电话!'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
      },
      visible: false,
      listImageUrl: '',
      detailImageUrl: '',
      listImageUrlCert: [],
      openImg: '',
      srcList: [
        'http://192.168.1.111/zentao/file-read-4867.png',
        'http://192.168.1.111/zentao/file-read-4867.png',
      ],
      gameSystems: [], // 赛制
      pxLevel1: [],
      pxLevel2: [],
      pxLevel_single: [
        { value: 0, label: '0.0' },
        { value: 0.5, label: '0.5' },
        { value: 1, label: '1.0' },
        { value: 1.5, label: '1.5' },
        { value: 2, label: '2.0' },
        { value: 2.5, label: '2.5' },
        { value: 3, label: '3.0' },
        { value: 3.5, label: '3.5' },
        { value: 4, label: '4.0' },
        { value: 4.5, label: '4.5' },
        { value: 5, label: '5.0' },
      ],
      allowPlayOffData: [
        { label: '第三四名争夺季军', value: 1 },
        { label: '无附加赛', value: 0 }
      ],
      showQuill: false // 这个字段是用来解决Quill富文本编辑器在初始化后会自动聚焦从而导致页面自动滚动的bug
    };
  },
  // created () {
  //   this.pdfs = []
  //     // this.$refs['d2-quill'].quill.blur();
  // },
  // destroyed () {
  // },
  mounted () {
    //this.restaurants = this.loadAll()
    this.initCity();
    // 获取赛制属性列表(字典项) // E_CERT_ REWARD_LEVEL 电子证书 MATCH_FORMAT 赛制
    commomDictData('MATCH_FORMAT', this).then((res) => {
      this.gameSystems = res.list;
    });
  },
  // updated () {
  // },
  methods: {
    openForm () {
      this.pdfs = [];
    },
    handleLoading (file) {
      for (let i = 0; i < this.pdfs.length; i++) {
        if (this.pdfs[i].fileName == file.name) {
          this.$message.error('文件已存在');
          return false;
        }
      }
      let files = file.name.split('.');
      let fileSuffix = files[files.length - 1];
      if (fileSuffix != 'pdf' && fileSuffix != 'doc' && fileSuffix != 'docx') {
        this.$message.error('只能上传pdf，doc和docx格式的文档');
        return false;
      }
      let pdf = {};
      pdf.fileName = file.name;
      pdf.url = '';
      pdf.loading = 0;
      pdf.loaded = false;
      this.pdfs.push(pdf);
      let timer = setInterval(() => {
        if (pdf.loaded) {
          clearInterval(timer);
          pdf.loading = 100;
        } else {
          if (pdf.loading < 99) {
            pdf.loading++;
          }
        }
      }, 100);
    },
    deletePdf (index) {
      let tips = '确定删除？';
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.pdfs.splice(index, 1);
          this.$message.success('已删除');
        })
        .catch(() => {
          this.$message.info('已取消！');
        });
    },
    savePdfUrl (res, file, fileList) {
      this.$message.success('上传成功');
      for (let i = 0; i < this.pdfs.length; i++) {
        if (this.pdfs[i].fileName == res.bean.fileName) {
          this.pdfs[i].url = res.path + res.bean.url;
          this.pdfs[i].loading = 100;
          this.pdfs[i].ossId = res.bean.id;
          this.pdfs[i].loaded = true;
          return 0;
        }
      }
    },
    loadingFail () {
      this.$message.error('上传失败');
    },
    levelAll () {
      if (this.ruleForm.projectType === 1) {
        this.ruleForm.minLevel = '0.0';
        this.ruleForm.maxLevel = '5.0';
      } else {
        this.ruleForm.minLevel = '5.0';
        this.ruleForm.maxLevel = '10.0';
      }
    },
    // 晋级人数
    promotedNumber (val) {
      if (this.ruleForm.applySize && this.ruleForm.groupNum) {
        if (
          Number(this.ruleForm.groupRiseNum) >
          Number(this.ruleForm.applySize) / Number(this.ruleForm.groupNum)
        ) {
          this.ruleForm.groupRiseNum = '';
          this.$message({
            type: 'info',
            message: `晋级人数不能超过小组人数`,
          });
          this.$forceUpdate();
        }
      } else {
        this.$message({
          type: 'info',
          message: `请填写签位数和组数`,
        });
      }
    },
    // 组数
    changeGpnumber () {
      // this.$forceUpdate();
      // 修改第二赛制验证限制
      if (this.ruleForm.groupNum == 1 || this.ruleForm.groupNum == '') {
        this.ruleForm.SecondCompetition = '';
        this.ruleForm.crossNum = '';
      }
      // 如果第二赛制为同名次小组循环赛需要验证
      if (this.ruleForm.SecondCompetition == 2) {
        if (this.ruleForm.groupNum >= 2 && this.ruleForm.groupNum <= 6) {
        } else {
          return this.tiemchecking();
        }
      }
      // 如果第二赛制为淘汰赛需要验证
      // if (this.ruleForm.SecondCompetition == 4) {
      //   if (
      //     this.ruleForm.applySize / this.ruleForm.groupNum === 2 ||
      //     this.ruleForm.applySize / this.ruleForm.groupNum === 4 ||
      //     this.ruleForm.applySize / this.ruleForm.groupNum === 6
      //   ) {
      //   } else {
      //     return this.applychecking1();
      //   }
      // }
      // 签位和组数的验证
      // if (
      //   this.ruleForm.groupNum !== '' &&
      //   this.ruleForm.groupNum !== null &&
      //   this.ruleForm.applySize !== '' &&
      //   this.ruleForm.applySize !== null
      // ) {
      //   if (
      //     this.ruleForm.applySize / this.ruleForm.groupNum === 2 ||
      //     this.ruleForm.applySize / this.ruleForm.groupNum === 3 ||
      //     this.ruleForm.applySize / this.ruleForm.groupNum === 4 ||
      //     this.ruleForm.applySize / this.ruleForm.groupNum === 5 ||
      //     this.ruleForm.applySize / this.ruleForm.groupNum === 6
      //   ) {
      //   } else {
      //     return this.applychecking();
      //   }
      // }
    },
    // 签位数
    changeappsize () {
      // 签位数应小于64
      if (this.ruleForm.FirstCompetition == 0) {
        if (this.ruleForm.applySize > 64) {
          return this.applytesting();
        }
      }
      if ([6, 7].includes(this.ruleForm.FirstCompetition)) {
        this.ruleForm.FirstCompetition = ''
      }
      if (this.ruleForm.applySize == 6) {
        this.FirstCompetition[3].disabled = false
      } else {
        this.FirstCompetition[3].disabled = true
      }
      if (this.ruleForm.applySize == 2) {
        this.FirstCompetition[4].disabled = false
      } else {
        this.FirstCompetition[4].disabled = true
      }
      // 签位和组数的验证
      // if (
      //   this.ruleForm.groupNum !== '' &&
      //   this.ruleForm.groupNum !== null &&
      //   this.ruleForm.applySize !== '' &&
      //   this.ruleForm.applySize !== null
      // ) {
      //   if (this.ruleForm.SecondCompetition == 4) {
      //     if (
      //       this.ruleForm.applySize / this.ruleForm.groupNum === 2 ||
      //       this.ruleForm.applySize / this.ruleForm.groupNum === 4 ||
      //       this.ruleForm.applySize / this.ruleForm.groupNum === 6
      //     ) {
      //     } else {
      //       return this.applychecking1();
      //     }
      //   } else {
      //     if (
      //       this.ruleForm.applySize / this.ruleForm.groupNum === 2 ||
      //       this.ruleForm.applySize / this.ruleForm.groupNum === 3 ||
      //       this.ruleForm.applySize / this.ruleForm.groupNum === 4 ||
      //       this.ruleForm.applySize / this.ruleForm.groupNum === 5 ||
      //       this.ruleForm.applySize / this.ruleForm.groupNum === 6
      //     ) {
      //     } else {
      //       return this.applychecking();
      //     }
      //   }
      // }
    },
    // changeGroupNum
    changeGroupNum () {
      this.$forceUpdate();
      this.$refs.ruleForm.validateField('allowPlayOff1')
    },

    changeSecondCompeti () {
      this.$forceUpdate();
      // 如果第二赛制为淘汰赛需要验证
      if (this.ruleForm.SecondCompetition != 4) {
        this.ruleForm.crossNum = '';
      } else {
        // if (
        //   this.ruleForm.applySize / this.ruleForm.groupNum === 2 ||
        //   this.ruleForm.applySize / this.ruleForm.groupNum === 4 ||
        //   this.ruleForm.applySize / this.ruleForm.groupNum === 6
        // ) {
        // } else {
        //   return this.applychecking1();
        // }
      }
      // 如果第二赛制为同名次小组循环赛需要验证
      if (this.ruleForm.SecondCompetition == 2) {
        if (this.ruleForm.groupNum >= 2 && this.ruleForm.groupNum <= 6) {
        } else {
          return this.tiemchecking();
        }
      }

      // 选择淘汰赛时，默认附加规则
      if (this.ruleForm.SecondCompetition === 5) {
        this.ruleForm.allowPlayOff1 = 1;
      } else {
        this.ruleForm.allowPlayOff1 = null;
      }
      this.$refs.ruleForm.validateField('allowPlayOff1')
    },
    changecrossNum () {
      this.$forceUpdate();
    },
    changeFirstCompetition () {
      // 第一赛制选择的限制
      if (
        this.ruleForm.FirstCompetition == 0 ||
        this.ruleForm.FirstCompetition == '' ||
        this.ruleForm.FirstCompetition === 5
      ) {
        this.ruleForm.groupNum = '';
        this.ruleForm.groupRiseNum = '';
        this.ruleForm.SecondCompetition = '';
        this.ruleForm.crossNum = '';

        if (this.ruleForm.applySize > 64) {
          this.applytesting();
        }
      }
      if ([6, 7].includes(this.ruleForm.FirstCompetition)) {
        this.ruleForm.groupNum = 1 // 组数
        this.ruleForm.SecondCompetition = '' // 第二阶段赛制
        this.ruleForm.groupRiseNum = '' // 小组晋级人数
        this.ruleForm.crossNum = '' // 交叉数
        this.ruleForm.allowPlayOff1 = '' // 第二阶段赛制-附加规则
      }
      // 选择淘汰赛时，默认附加规则
      if (this.ruleForm.FirstCompetition === 5) {
        this.ruleForm.allowPlayOff = 0;
      } else {
        this.ruleForm.allowPlayOff = null;
      }

      this.$forceUpdate();
    },
    changeAllowPlayOff () {
      this.$forceUpdate();
    },
    changeAllowPlayOff1 () {
      this.$forceUpdate();
    },
    tiemchecking () {
      this.$alert(
        '因二阶段同名次小组循环赛系统支持2-6签的小组对阵，故一阶段小组循环赛分组数也需满足2-6组。请重新设置组数！',
        '提示',
        {
          confirmButtonText: '确定',
          callback: (action) => {
            this.$message({
              type: 'info',
              message: `请重新设置`,
            });
          },
        }
      );
      return false;
    },
    groupNumNull () {
      this.$alert('赛制为小组循环赛，组数不能位空！！', '提示', {
        confirmButtonText: '确定',
        callback: (action) => {
          this.$message({
            type: 'info',
            message: `请重新设置`,
          });
        },
      });
      return false;
    },
    applytesting () {
      this.$alert('当前系统支持最大签位数为64签。请重新设置！', '提示', {
        confirmButtonText: '确定',
        callback: (action) => {
          this.$message({
            type: 'info',
            message: `请重新设置`,
          });
        },
      });
      return false;
    },
    applychecking () {
      this.$alert(
        '当前系统支持单组（即总签位数/组数）签位数为2/3/4/5/6签。请重新设置！',
        '提示',
        {
          confirmButtonText: '确定',
          callback: (action) => {
            this.$message({
              type: 'info',
              message: `请重新设置`,
            });
          },
        }
      );
      return false;
    },
    applychecking1 () {
      this.$alert(
        '当前系统支持单组（即总签位数/组数）签位数为2/4/6签。请重新设置！',
        '提示',
        {
          confirmButtonText: '确定',
          callback: (action) => {
            this.$message({
              type: 'info',
              message: `请重新设置`,
            });
          },
        }
      );
    },
    // 删除电子证书
    deletecertImg (item, index) {
      this.listImageUrlCert.splice(index, 1);
    },
    // 鼠标移入
    hoverover (item) {
      this.deletesId = item.imgUrl;
    },
    hoverover1 (item) {
      this.activecolor = item.imgUrl;
      // this.$nextTick(() => {
      //   this.activecolor = item.id
      // })
      // this.$set(this.activecolor, item.id)
    },
    // 鼠标移出
    hoverout (item) {
      this.deletesId = -1;
    },
    hoverout2 (item) {
      this.activecolor = -1;
    },
    init (id, flagType) {
      this.clickFlag = false;
      this.flagType = flagType;
      this.ruleForm.id = id || null;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs['ruleForm'].resetFields();
        this.$refs['d2-quill'].Quill.pasteHTML('');
        this.$refs.gameDescription.Quill.pasteHTML('');
      });
      //数据初始化
      this.isReviewedEdit = false;
      this.isInGameManagementMode = false;
      this.ruleForm.level = '';
      this.levelDisabled = true;
      this.ruleForm.placeInfo = ''
      this.ruleForm.__placeInfoTemp__ = [{ name: '' }]
      this.placeholderLevel = '必须先选择比赛项目';
      this.ctDisabled = true;
      this.matchStartTimePlaceholder = '必须先选择报名时间';
      this.listImageUrl = '';
      this.detailImageUrl = '';
      this.ruleForm.ageMinMen = undefined;
      this.ruleForm.ageMaxMen = undefined;
      this.ruleForm.ageMinWomen = undefined;
      this.ruleForm.ageMaxWomen = undefined;
      this.ctRefund.minDuration = 0;
      this.ctRefund.refundScale = 0;
      this.ctRefund.index = 0;
      this.ruleForm.ctRefundList = [];
      this.delTableList = [];
      this.ruleForm.matchSignStartTime = '';
      this.ruleForm.matchSignEndTime = '';
      this.ruleForm.recommend = 0;
      this.ruleForm.applySize = '';
      this.ruleForm.FirstCompetition = '';
      this.ruleForm.groupNum = '';
      this.ruleForm.SecondCompetition = '';
      this.ruleForm.CrossingNum = '';
      this.selClear();
      this.cityDisbaled = true;
      this.provinceDisabled = true;
      this.venueIdDisabled = true;
      this.womenDisabled = false;
      this.menDisabled = false;
      this.nameFont = 40;

      this.dataInit();
      this.listImageUrlCert = [];
      setTimeout(() => {
        this.showQuill = true
      }, 1000)
      //修改回选
      if (this.ruleForm.id) {
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/getId/` + this.ruleForm.id),
          method: 'get',
        }).then((data) => {
          if (data && data.code === 0) {
            this.changeCity(data.bean.userGroupId);
            this.changeProjectType(data.bean.projectType);
            this.genderLimitChange(data.bean.genderLimit);
            this.ruleForm = data.bean;
            this.ruleForm.smallLevel = data.bean.level.split('~')[0]
            this.ruleForm.bigLevel = data.bean.level.split('~')[1] ? data.bean.level.split('~')[1] : this.$set(this.ruleForm, 'bigLevel', '')
            this.$set(this.ruleForm, '__placeInfoTemp__', data.bean.placeInfo.split(',').map(item => { return { name: item } }))
            this.listImageUrl = data.bean.imgUrlList;
            this.detailImageUrl = data.bean.imgUrlDetail;
            this.changeProvice(0);
            this.selectCity(0);
            this.dataInit();
            this.nameFont = 40 - data.bean.matchName.length;
            // this.ruleForm.applyDate = [];
            // this.ruleForm.applyDate.push(data.bean.matchSignStartTime + '');
            // this.ruleForm.applyDate.push(data.bean.matchSignEndTime + '');
            this.$set(this.ruleForm, 'applyDate', [data.bean.matchSignStartTime, data.bean.matchSignEndTime])
            this.pdfs = data.bean.attachmentsList
              ? data.bean.attachmentsList
              : [];
            if (this.pdfs.length > 0) {
              for (let i = 0; i < this.pdfs.length; i++) {
                this.pdfs[i].loading = 100;
              }
            }

            this.ruleForm.recommend = data.bean.recommend;

            if (data.bean.competitionMatchFormatList.length != 0) {
              this.ruleForm.FirstCompetition =
                data.bean.competitionMatchFormatList[0].matchFormat;
              this.ruleForm.allowPlayOff =
                data.bean.competitionMatchFormatList[0].allowPlayOff;
              this.ruleForm.groupNum =
                data.bean.competitionMatchFormatList[0].groupNum;
              this.ruleForm.groupRiseNum =
                data.bean.competitionMatchFormatList[0].groupRiseNum;
              if (data.bean.competitionMatchFormatList.length > 1) {
                this.ruleForm.SecondCompetition =
                  data.bean.competitionMatchFormatList[1].matchFormat;
                this.ruleForm.allowPlayOff1 =
                  data.bean.competitionMatchFormatList[1].allowPlayOff;
                this.ruleForm.crossNum =
                  data.bean.competitionMatchFormatList[1].crossNum != null
                    ? data.bean.competitionMatchFormatList[1].crossNum
                    : '';
              } else {
                this.ruleForm.SecondCompetition = null;
                this.ruleForm.crossNum = null;
              }
            } else {
              this.ruleForm.FirstCompetition = null;
              this.ruleForm.groupNum = null;
              this.ruleForm.SecondCompetition = null;
              this.ruleForm.crossNum = null;
            }

            // this.listImageUrlCert = data.bean.ecertList
            if (data.bean.ecertList.length > 0) {
              data.bean.ecertList.forEach((element) => {
                let come = {
                  imgUrl: '',
                  rewardLevel: '',
                };
                come.rewardLevel = element.rewardLevel;
                come.imgUrl = element.imgUrl;
                this.listImageUrlCert.push(come);
              });
            }
            this.ruleForm.ctEnrollPriceList = Array.from(
              this.ruleForm.ctEnrollPriceList
            );
            for (let i of data.eList) {
              for (let j of this.ruleForm.ctEnrollPriceList) {
                if (i.type === j.type) {
                  j.id = i.id;
                  j.price = i.price;
                  break;
                }
              }
            }
            this.ruleForm.ctRefundList = [];
            let index = 1;
            for (let i of data.rList) {
              this.ruleForm.ctRefundList.push({
                index: index++,
                minDuration: i.minDuration,
                refundScale: i.refundScale,
              });
            }
            this.levelDisabled = false;
            this.ctDisabled = false;
            // 非未审核状态编辑（部分控制不可修改）
              if (flagType === 'reviewedEdit') {
                this.isReviewedEdit = true
                if (this.ruleForm.inGameManagementMode == 0) {
                  this.isInGameManagementMode = true
                } else {
                  this.isInGameManagementMode = false
                }
              }
            this.$nextTick(() => {
              this.$refs['d2-quill'].Quill.pasteHTML(
                data.bean.matchDescription
              );
              this.$refs.gameDescription.Quill.pasteHTML(
                data.bean.gameDescription
              );
            });
          }
        });
      }
    },
    selectCity (flag) {
      if (flag !== 0) {
        this.venueList = [];
        this.ruleForm.venueId = '';
      }
      this.$http({
        url: this.$http.adornUrl('/pbPlaces/getPlaceById'),
        method: 'get',
        params: this.$http.adornParams({
          orgId: this.ruleForm.userGroupId,
          proviceId: this.ruleForm.provinceCode,
          cityId: this.ruleForm.cityCode,
        }),
      }).then((data) => {
        let obj = {};
        let val = this.ruleForm.cityCode;
        if (val) {
          obj = this.cityList.find((item) => {
            return item.citycode === val;
          });
          if (obj) {
            this.ruleForm.cityName = obj.cityname;
          }
        }
        this.venueList = data && data.code === 0 ? data.list : [];
      });
    },
    changeProvice (flag) {
      if (flag !== 0) {
        this.cityList = [];
        this.ruleForm.cityCode = '';
        this.venueList = [];
        this.ruleForm.venueId = '';
      }
      this.$http({
        url: this.$http.adornUrl('/dicProvinceCity/queryByOrgId'),
        method: 'get',
        params: this.$http.adornParams({
          orgId: this.ruleForm.userGroupId,
          provinceCode: this.ruleForm.provinceCode,
        }),
      }).then((data) => {
        let obj = {};
        let val = this.ruleForm.provinceCode;
        if (val) {
          obj = this.provinceList.find((item) => {
            return item.code === val;
          });
          if (obj) {
            this.ruleForm.provinceName = obj.name;
          }
        }

        this.cityList = data.list;
      });
    },
    dataInit () {
      this.ruleForm.ctEnrollPriceList = [
        {
          name: '注册会员',
          type: 1,
          price: 0.0,
        },
        {
          name: '初始会员',
          type: 2,
          price: 0.0,
        },
        {
          name: '荣誉会员',
          type: 3,
          price: 0.0,
        },
      ];

      //初始化可报名的赛事类型
      this.$http({
        url: this.$http.adornUrl('/sysOrg/getSysOrgByUserId'),
        method: 'get',
      }).then((data) => {
        if (data.bean) {
          let arr = [];
          let typeList = data.bean.byx1.split(',');
          this.ctTypeList.forEach((c) => {
            typeList.forEach((t) => {
              if (t == c.key) {
                arr.push(c);
              }
            });
          });
          this.ctTypeList = arr;
        }
      });
    },
    // 比赛名称
    descInput () {
      let len = 40 - this.ruleForm.matchName.length;
      this.nameFont = len;
    },
    // loading
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    },
    //新增方法
    ruleFormSubmit () {
      this.ruleForm.ecertList = this.listImageUrlCert;
      this.$refs['ruleForm'].validate((valid) => {
        if (this.ruleForm.SecondCompetition == 4 || this.ruleForm.crossNum == null) {
          if (this.ruleForm.crossNum == '') {
            return this.$message.error('请选择交叉数')
          }
        }
        if (!this.ruleForm.groupNum && this.ruleForm.FirstCompetition == 1) {
          return this.$message.error('选择小组循环赛时，必须设置组数！')
        }
        if (this.ruleForm.FirstCompetition === 1) { // 小组循环赛
          if ([3, 4, 5].includes(this.ruleForm.SecondCompetition)) { // 同名次淘汰附加赛/交叉淘汰附加赛/淘汰赛
            const num = Number(this.ruleForm.groupNum)
            if (isNaN(num) || !(num > 0 && (num & (num - 1)) === 0)) { // 组数必须是2的幂次方
              return this.$alert(
                `第二阶段赛制为“${this.SecondCompetition.find(item => item.value === this.ruleForm.SecondCompetition).label}”时，组数必须为2的幂次方，如：2、4、8、16...，请重新设置！`,
                '提示',
                {
                  confirmButtonText: '确定',
                  callback: (action) => {
                    this.$message({
                      type: 'info',
                      message: `请重新设置`
                    })
                  }
                }
              )
            }
          }
        }
        if (!this.ruleForm.groupRiseNum && this.ruleForm.FirstCompetition == 1) {
          return this.$message.error('必须设置晋级人数！')
        }
        if (this.ruleForm.FirstCompetition === 1) { // 小组循环赛
          if ([4].includes(this.ruleForm.SecondCompetition)) { // 交叉淘汰附加赛
            const num = Number(this.ruleForm.groupRiseNum)
            if (num === 0 || num % 2 !== 0) { // 第一阶段小组晋级人数必须是大于0的偶数
              return this.$alert(
                `第二阶段赛制为“${this.SecondCompetition.find(item => item.value === this.ruleForm.SecondCompetition).label}”时，小组晋级人数必须为大于0的偶数，请重新设置！`,
                '提示',
                {
                  confirmButtonText: '确定',
                  callback: (action) => {
                    this.$message({
                      type: 'info',
                      message: `请重新设置`
                    })
                  }
                }
              )
            }
          }
        }
        if (this.ruleForm.inGameManagementMode == 0) {
          // 无赛中模式
          this.ruleForm.competitionMatchFormatList = [];
          this.ruleForm.FirstCompetition = ''; // 第一赛制清空
          this.ruleForm.groupNum = ''; // 组数清空
          this.ruleForm.allowPlayOff = ''; // 附加规则清空 第一阶段
          this.ruleForm.SecondCompetition = ''; // 第二赛制清空
          this.ruleForm.allowPlayOff = ''; // 附加规则清空 第二阶段
          this.ruleForm.crossNum = ''; // 交叉树清空
        } else {
          // 赛中模式
          // 赛制添加
          this.ruleForm.competitionMatchFormatList = [
            {
              matchFormat: this.ruleForm.FirstCompetition,
              stage: 1,
              groupNum: this.ruleForm.groupNum,
            },
            {
              matchFormat: this.ruleForm.SecondCompetition,
              stage: 2,
              crossNum: this.ruleForm.crossNum,
            },
          ];
          // 如果第二赛制为同名次小组循环赛需要验证
          if (this.ruleForm.SecondCompetition == 2) {
            if (this.ruleForm.groupNum >= 2 && this.ruleForm.groupNum <= 6) {
            } else {
              return this.tiemchecking();
            }
          }
          if (
            this.ruleForm.SecondCompetition == '' ||
            this.ruleForm.SecondCompetition == null
          ) {
            if (this.ruleForm.groupNum > 1) {
              return this.$message.error(
                '赛制仅为小组循环赛，组数只支持单组！'
              );
            }
          }
          // 组数和签位之间的限制
          if (this.ruleForm.FirstCompetition == 1) {
            if (this.ruleForm.groupNum == '') {
              return this.groupNumNull();
            }
          }
          if (
            this.ruleForm.FirstCompetition == 0 ||
            this.ruleForm.FirstCompetition == ''
          ) {
            this.ruleForm.groupNum = '';
            this.ruleForm.SecondCompetition = '';
            this.ruleForm.crossNum = '';
            if (this.ruleForm.applySize > 64) {
              return this.applytesting();
            }
          }
          // 组数和签位之间的限制
          // if (
          //   this.ruleForm.groupNum !== '' &&
          //   this.ruleForm.groupNum !== null &&
          //   this.ruleForm.applySize !== '' &&
          //   this.ruleForm.applySize !== null
          // ) {
          //   if (
          //     this.ruleForm.applySize / this.ruleForm.groupNum === 2 ||
          //     this.ruleForm.applySize / this.ruleForm.groupNum === 3 ||
          //     this.ruleForm.applySize / this.ruleForm.groupNum === 4 ||
          //     this.ruleForm.applySize / this.ruleForm.groupNum === 5 ||
          //     this.ruleForm.applySize / this.ruleForm.groupNum === 6
          //   ) {
          //   } else {
          //     return this.applychecking();
          //   }
          // }
          // 设置附加规则 第一阶段
          this.ruleForm.competitionMatchFormatList[0].allowPlayOff =
            this.ruleForm.allowPlayOff;
          this.ruleForm.competitionMatchFormatList[0].playOffPlace =
            this.ruleForm.allowPlayOff === 0 ? 0 : 4;

          // 晋级人数
          this.ruleForm.competitionMatchFormatList[0].groupRiseNum =
            this.ruleForm.groupRiseNum;
          // 设置附加规则 第二阶段
          this.ruleForm.competitionMatchFormatList[1].allowPlayOff =
            this.ruleForm.allowPlayOff1;
          // this.ruleForm.competitionMatchFormatList[1].playOffPlace =
          //   this.ruleForm.allowPlayOff === 0 ? 0 : 4;
        }

        if (this.ruleForm.ctRefundList.length < 1) {
          return this.$message.error('必须设置退费规则！');
        } else if (this.ruleForm.ctEnrollPriceList.some((e) => e.price == 0)) {
          return this.$message.error('费用设置不能为0！');
        } else if (this.ruleForm.ecertList.length < 1) {
          return this.$message.error('请上传电子证书！');
        }
        if (
          !this.ruleForm.matchDescription ||
          this.ruleForm.matchDescription === '<p><br></p>'
        ) {
          return this.$message.error('比赛简介不能为空！');
        }

        this.ruleForm.attachmentsList = this.pdfs;
        this.ruleForm.level = this.ruleForm.smallLevel + '~' + this.ruleForm.bigLevel
        if (valid) {
          this.ruleForm.matchSignStartTime = this.ruleForm.applyDate[0];
          this.ruleForm.matchSignEndTime = this.ruleForm.applyDate[1];
          if (this.ruleForm.inGameManagementMode == 1) {
            this.ruleForm.placeInfo = this.ruleForm.__placeInfoTemp__.map(item => item.name).join(',')
          } else {
            this.ruleForm.placeInfo = ''
          }
          this.$confirm(`本场比赛您设置了${this.ruleForm.__placeInfoTemp__.length}块场地，签位数量为${this.ruleForm.applySize}，请核对设置信息！`, '场地信息确认', {
            confirmButtonText: '确认无误',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            this.$showLoading()
            this.clickFlag = true
            this.$http({
              url: this.$http.adornUrl(
                `/ctCompetition/${!this.ruleForm.id ? 'save' : this.isReviewedEdit ? 'updateApproved' : 'update'}`
              ),
              method: 'post',
              data: this.ruleForm,
            }).then((data) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.flagType = 1
                    this.visible = false
                    this.$emit('refreshDataList')
                    this.$showLoading('close')
                  },
                });
              } else {
                this.clickFlag = false
                this.$message.error(data.msg)
                this.$showLoading('close')
              }
            }).catch(() => {
              this.clickFlag = false
            })
          })
          .catch(() => {
            this.$message.info('已取消')
          })
        }
      })
    },
    // 关闭
    closeForm () {
      this.showQuill = false
      if (this.flagType === 2) {
        this.$http({
          url: this.$http.adornUrl(`/ctCompetition/delete/` + this.ruleForm.id),
          method: 'get',
        }).then((data) => {
          this.visible = false;
        });
      } else {
        this.visible = false;
      }
    },

    //报名时间改变事件
    applyDateChange () {
      if (this.ruleForm.applyDate == null) {
        this.ctDisabled = true;
        this.ruleForm.matchStartTime = null;
        this.matchStartTimePlaceholder = '必须先选择报名时间';
      } else {
        this.ctDisabled = false;
        this.ruleForm.matchStartTime = null;
        this.matchStartTimePlaceholder = '请选择比赛时间';
        this.pickerOptionsCt = {
          disabledDate: (time) => {
            return (
              time < new Date(this.ruleForm.applyDate[1]) - 1000 * 60 * 59 * 24
            );
          },
        };
      }
    },
    // 比赛时间
    changeMatchStartTime (val) {
      if (this.ruleForm.matchStartTime) {
        let date1 = new Date(this.ruleForm.applyDate[1]).getTime();
        let date2 =
          new Date(this.ruleForm.matchStartTime).getTime() - 1000 * 60;
        if (date1 > date2) {
          this.ruleForm.matchStartTime = null;
          this.matchStartTimePlaceholder =
            '比赛时间必须晚于报名截止时间，请重新选择';
        }
      }
    },
    //打开图片剪裁框
    openImgdailog (type) {
      this.openImg = true;
      this.$nextTick(() => {
        if (type === 1) {
          this.$refs.upimg.init('ctLevel'); //传入图片类型参数
        }
        if (type === 2) {
          this.$refs.upimg2.init('ctLevel'); //传入图片类型参数
        }
        if (type === 3) {
          if (this.ruleForm.prizeList) {
            this.$refs.upimg3.init('ctLevel'); //传入图片类型参数
          } else {
            this.$message.error('请选择奖项等级');
          }
        }
      });
    },
    //剪裁完成的回显 列表页
    doneup_lb (val, url) {
      this.ruleForm.imgList = val;
      this.listImageUrl = url;
      this.openImg = false;
    },
    //电子整数 列表页
    doneup_Cert (val, url, path) {
      this.ruleForm.CertimgList = val;
      let arr = {
        imgUrl: path,
        rewardLevel: this.ruleForm.prizeList,
      };
      if (this.verificationBook(path)) {
        this.listImageUrlCert.push(arr);
      }
      this.openImg = false;
    },
    // 验证证书是否已经上传
    verificationBook (path) {
      let arr = 1;

      this.listImageUrlCert.forEach((item, index) => {
        if (item.rewardLevel == this.ruleForm.prizeList) {
          this.listImageUrlCert[index].imgUrl = path;
          arr = 0;
          throw Error();
        }
        arr = 1;
      });
      if (arr === 0) {
        return false;
      } else {
        return true;
      }
    },
    //剪裁完成的回显 详情页
    doneup_xq (val, url) {
      this.ruleForm.imgDetailList = val;
      this.detailImageUrl = url;
      this.openImg = false;
    },
    //自定义上传方法
    //没有用el-upload的action方法，如果使用要传递headers属性参数授权
    /*  uploadFileList (param) {
                //列表页图
                this.uploadFile('1', param.file)
            },
            uploadFileDetail (param) {
                //列表页图
                this.uploadFile('2', param.file)
            },
            uploadFile (type, file) {
                let fd = new FormData()
                fd.append('type', 'ctLevel')
                fd.append('file', file)

                this.$http({
                    url: this.$http.adornUrl(`/upload/uploadFile`),
                    method: 'post',
                    data: fd
                }).then((data) => {
                    if (data && data.code === 0) {
                        //列表页图
                        if (type === '1') {
                            this.ruleForm.imgList = data.bean.id
                            this.listImageUrl = URL.createObjectURL(file)
                        }
                        //详情页图
                        if (type === '2') {
                            this.ruleForm.imgDetailList = data.bean.id
                            this.detailImageUrl = URL.createObjectURL(file)
                        }
                        this.$message.success('上传成功!')
                    } else {
                        this.$message.error('上传失败!')
                    }
                })
            }, */
    // querySearchApplySize(queryString, cb){
    //     let restaurants = this.restaurants;
    //     let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
    //     // 调用 callback 返回建议列表的数据
    //     cb(results);
    // },
    // createFilter(queryString) {
    //     return (restaurant) => {
    //         return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //     };
    // },
    // loadAll(){
    //     return [
    //         {'value':'2签位'},
    //         {'value':'4签位'},
    //         {'value':'8签位'},
    //         {'value':'16签位'},
    //         {'value':'64签位'},
    //         {'value':'128签位'}
    //     ]
    // },
    //比赛项目改变事件
    changeProjectType (value) {
      if (value) {
        this.levelDisabled = false;
        this.placeholderLevel = '请选择级别';
        if (value === 1 || value === 3) {
          this.levelOptions = this.levelOptionsOne;
          this.pxLevel1 = JSON.parse(JSON.stringify(this.pxLevel_single));
          this.pxLevel2 = JSON.parse(JSON.stringify(this.pxLevel_single));
        } else {
          this.levelOptions = this.levelOptionsTwo;
          this.pxLevel1 = JSON.parse(JSON.stringify(this.pxLevel_double));
          this.pxLevel2 = JSON.parse(JSON.stringify(this.pxLevel_double));
        }
      } else {
        this.levelDisabled = true;
        this.levelOptions = [];
        this.pxLevel1 = [];
        this.pxLevel2 = [];
        this.placeholderLevel = '必须先选择比赛项目';
      }
      this.ruleForm.level = '';
      this.ruleForm.minLevel = '';
      this.ruleForm.maxLevel = '';
      this.ruleForm.smallLevel = '';
      this.ruleForm.bigLevel = '';
    },
    // 初始设置级别与级别限定联动
    // changeLevel(value) {
    //   this.ruleForm.minLevel = value;
    //   this.ruleForm.maxLevel = value;
    // },
    changeSmallLevel (value) {
       this.ruleForm.minLevel = value;
       this.pxLevel1.map(item => {
        if (item.value < Number(value)) {
          item.disabled = true
        } else {
          item.disabled = false
        }
        })
    },
    changeBigLevel (value) {
       this.ruleForm.maxLevel = value;
       this.pxLevel2.map(item => {
         if (item.value > Number(value)) {
            item.disabled = true
          } else {
            item.disabled = false
          }
       })
    },

    startAgeMenChange (value) {
      this.ageMaxMenMin = value;
    },
    endAgeMenChange (value) {
      this.ageMaxMenMax = value;
    },
    startAgeWomenChange (value) {
      this.ageMaxWomenMin = value;
    },
    endAgeWomenChange (value) {
      this.ageMaxWomenMax = value;
    },
    genderLimitChange (label) {
      //男
      if (label === 0) {
        this.womenDisabled = true;
        this.menDisabled = false;
        this.ruleForm.ageMinWomen = undefined;
        this.ruleForm.ageMaxWomen = undefined;
      }
      //女
      if (label === 1) {
        this.menDisabled = true;
        this.womenDisabled = false;
        this.ruleForm.ageMinMen = undefined;
        this.ruleForm.ageMaxMen = undefined;
      }
      //全部
      if (label === 2) {
        this.menDisabled = false;
        this.womenDisabled = false;
      }
    },
    // table多选事件
    selectionChangeHandle (val) {
      this.delTableList = val;
      if (this.delTableList.length === 0) {
        this.delCtRefundDisabled = true;
      } else {
        this.delCtRefundDisabled = false;
      }
    },
    //退款设置添加事件
    addCtRefund () {
      if (this.ctRefund.minDuration === undefined) {
        this.$message.error('距比赛开始时间不能为空!');
        return;
      }
      if (this.ctRefund.refundScale === undefined) {
        this.$message.error('退款比例不能为空!');
        return;
      }
      let arr = {
        index: this.ruleForm.ctRefundList.length + 1,
        minDuration: this.ctRefund.minDuration,
        refundScale: this.ctRefund.refundScale,
      };
      this.ruleForm.ctRefundList.push(arr);
    },
    //退款设置删除事件
    delCtRefund () {
      for (let i of this.delTableList) {
        this.ruleForm.ctRefundList.splice(i.index - 1, 1);
        for (let j = 0; j < this.ruleForm.ctRefundList.length; j++) {
          this.ruleForm.ctRefundList[j].index = j + 1;
        }
      }
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get',
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : [];
      });
    },
    selClear () {
      this.placesInfoList = [];
      this.ruleForm.venueAddress = '';
      this.ruleForm.venueId = '';
      this.venueList = [];
      this.ruleForm.cityCode = '';
      this.ruleForm.cityName = '';
      this.cityList = [];
      this.ruleForm.provinceCode = '';
      this.ruleForm.provinceName = '';
      this.provinceList = [];
    },
    changeCity (val) {
      this.selClear();
      if (val === '' || val === null) {
        this.cityDisbaled = true;
        this.provinceDisabled = true;
        this.venueIdDisabled = true;
        return;
      } else {
        this.cityDisbaled = false;
        this.provinceDisabled = false;
        this.venueIdDisabled = false;
      }
      this.getById(val);
    },
    //获取省和市
    getById (val) {
      this.$http({
        url: this.$http.adornUrl(`/dicProvince/queryByOrgId/` + val),
        params: this.$http.adornParams({
          orgId: val,
        }),
        method: 'get',
      }).then((data) => {
        if (data && data.code === 0) {
          // this.cityList.push({
          //     label : data.bean.cityName,
          //     value : data.bean.cityCode
          // })
          // this.ruleForm.cityCode = data.bean.cityCode
          // this.ruleForm.cityName = data.bean.cityName
          // this.provinceList.push({
          //     label : data.bean.proviceName,
          //     value : data.bean.code
          // })
          // this.ruleForm.provinceCode = data.bean.code
          // this.ruleForm.provinceName = data.bean.proviceName
          // this.getByOrgId(val)
          this.provinceList = data.list;
        }
      });
    },
    //获取主办方
    getByOrgId (val) {
      this.$http({
        url: this.$http.adornUrl(`/pbPlaces/getByOrgId/` + val),
        method: 'get',
      }).then((data) => {
        if (data && data.code === 0) {
          this.placesInfoList = data.pbPlacesList;
          for (let i of data.pbPlacesList) {
            this.venueList.push({
              label: i.name,
              value: i.id,
            });
          }
        }
      });
    },
    venueIdChange (val) {
      let obj = {};
      if (val) {
        obj = this.venueList.find((item) => {
          return item.id === val;
        });
        if (obj) {
          this.ruleForm.venueAddress = obj.address;
        }
      }

      // if(val == '' || val === null){
      //     this.ruleForm.venueAddress = ''
      // }else{
      //     this.placesInfoList.forEach(data =>{
      //         if(data.id == val){
      //             this.ruleForm.venueAddress = data.address
      //         }
      //     })
      // }
    },
    addFeeTemplate (type) {
      this.addFeeTemplateVisible = true;
      this.$nextTick(() => {
        this.$refs.addFeeTemplate.init(type);
      });
    },
    chooseTemplate (list, type) {
      this.addFeeTemplateVisible = false;
      if (type === 1) {
        this.ruleForm.ctEnrollPriceList = [];
        list.forEach((e) => {
          if (e.typeRole === 1 && e.typeVal === 1) {
            let da = {
              id: null,
              name: '注册会员',
              type: 1,
              price: e.value,
            };
            this.ruleForm.ctEnrollPriceList.push(da);
          } else if (e.typeRole === 1 && e.typeVal === 2) {
            let da = {
              id: null,
              name: '初始会员',
              type: 2,
              price: e.value,
            };
            this.ruleForm.ctEnrollPriceList.push(da);
          } else if (e.typeRole === 1 && e.typeVal === 3) {
            let da = {
              id: null,
              name: '荣誉会员',
              type: 3,
              price: e.value,
            };
            this.ruleForm.ctEnrollPriceList.push(da);
          }
        });
      } else if (type === 2) {
        this.ruleForm.ctRefundList = [];
        let index = 1;
        for (let i of list) {
          this.ruleForm.ctRefundList.push({
            index: index++,
            minDuration: i.typeVal,
            refundScale: i.value,
          });
        }
      }
    },
    addPlaceInfoTemp () {
      this.ruleForm.__placeInfoTemp__.push({ name: '' })
    },
    deletePlaceInfoTemp () {
      this.ruleForm.__placeInfoTemp__.pop()
    }
  },
};
</script>

<style scoped>
.el-dialog-custom {
  overflow: hidden !important;
}
.el-dialog-custom /deep/ .el-dialog__body {
  height: 73vh;
  overflow: auto;
}
.el-dialog-custom /deep/ .el-dialog__footer {
  border-top: 1px solid #E9E9E9;
}
</style>

<style>
.imagemore {
  /* display: inline-block; */
  margin-top: 20px;
}
.imagelist {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  align-items: center;
}
.infocont {
  display: inline-block;
  margin-right: 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
}
.deletes .el-icon-delete {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  color: white;
  font-size: 20px;
}
.chosecolor {
  color: #02b90d !important;
}
.deletes {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}
.deletes .Mask {
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.8;
  position: absolute;
  left: 0;
  top: 0;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #ccc;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.font_later {
  padding-left: 20px;
  font-weight: bold;
  color: #909399;
}
.font_color {
  font-weight: bold;
  color: #909399;
}
.font_style {
  font-weight: bold;
  color: red;
}
.dialog-footer {
  padding-bottom: 150px;
}
.dialog-right {
  float: right;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}

/* 文本框剩余数字提示兼容ie */
.el-input .el-input__count .el-input__count-inner {
  background: none;
  line-height: initial;
  display: inline-block;
  padding: 0 5px;
}
/* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}
</style>
<style lang="scss" scoped>
.rankLimit {
  display: flex;
  align-items: center;
  .select_width {
    width: 180px;
  }
  .btn {
    margin: 0 0 22px 15px;
  }
  .empty {
    margin: 0 0 22px 10px;
  }
  .ageStyle {
    margin-left: -130px;
    .el-form-item__error {
      width: 500px;
    }
  }
}
</style>
